"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DAOContract = void 0;

var utils_1 = require("./utils");

var DAOContract = /*#__PURE__*/function () {
  function DAOContract(contract) {
    _classCallCheck(this, DAOContract);

    this.contract = contract;
  }

  _createClass(DAOContract, [{
    key: "getCount",
    value: function () {
      var _getCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = parseInt;
                _context.next = 3;
                return this.contract.methods.catalystCount().call();

              case 3:
                _context.t1 = _context.sent;
                return _context.abrupt("return", (0, _context.t0)(_context.t1));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getCount() {
        return _getCount.apply(this, arguments);
      }

      return getCount;
    }()
  }, {
    key: "getCatalystIdByIndex",
    value: function getCatalystIdByIndex(index) {
      return this.contract.methods.catalystIds(index).call();
    }
  }, {
    key: "getServerData",
    value: function () {
      var _getServerData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(catalystId) {
        var _yield$this$contract$, id, owner, domain;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.contract.methods.catalystById(catalystId).call();

              case 2:
                _yield$this$contract$ = _context2.sent;
                id = _yield$this$contract$.id;
                owner = _yield$this$contract$.owner;
                domain = _yield$this$contract$.domain;
                return _context2.abrupt("return", {
                  id: id,
                  domain: domain,
                  owner: owner.toJSON()
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getServerData(_x) {
        return _getServerData.apply(this, arguments);
      }

      return getServerData;
    }()
  }], [{
    key: "withNetwork",
    value: function withNetwork(networkName) {
      var handler = (0, utils_1.handlerForNetwork)(networkName, 'catalyst');

      if (handler) {
        var contract = handler.contract;
        return new DAOContract(contract);
      } else {
        throw new Error("Can not find a network handler for Network=\"".concat(networkName));
      }
    }
  }]);

  return DAOContract;
}();

exports.DAOContract = DAOContract;